// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.NewArrivals.Correlated.Collection'
,	[
	   'Item.Collection'	
    ]
, function (
	ItemCollection
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
      this.searchApiMasterOptions= {
        fieldset : 'search'
       }
        this.itemsIds = [options.itemsIds]; 
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        //console.log(this.itemsIds)
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items) || [];
        const self = this;
        const items = {};
        return _.toArray(original_items);
    }

	});
});
